import { render } from "./ServicesOverviewReport.vue?vue&type=template&id=b6a0aa4a"
import script from "./ServicesOverviewReport.vue?vue&type=script&lang=js"
export * from "./ServicesOverviewReport.vue?vue&type=script&lang=js"

import "./ServicesOverviewReport.vue?vue&type=style&index=0&id=b6a0aa4a&lang=sass"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__